import React from 'react';
import { Link } from 'react-router-dom';
import { useImages } from '../context/ImageContext';
import Footer from '../components/Footer';

const MedicalAlertBraceletsPage: React.FC = () => {
  const { getImage } = useImages();

  const braceletImage = getImage('med-alert-bracelet.jpg');
  const accessorizeImage = getImage('unspecified-9-.jpg');
  const designerCollectionImage = getImage('designer-collection-alert1-accessories.jpg');

  return (
    <div className="medical-alert-bracelets-page">
      {/* Hero Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '2rem', color: '#c8102e', textAlign: 'center' }}>
            Medical Alert Bracelets with Help Buttons
          </h1>
          
          <div style={{ overflow: 'hidden' }}>
            {braceletImage && (
              <img 
                src={braceletImage} 
                alt="Medical Alert Bracelet" 
                style={{ 
                  float: 'right',
                  maxWidth: '350px',
                  width: '100%',
                  height: 'auto',
                  marginLeft: '1.5rem',
                  marginBottom: '1rem',
                  marginTop: '0',
                  paddingTop: '0',
                  borderRadius: '8px'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444', paddingTop: '0', marginTop: '0' }}>
              <p style={{ marginBottom: '1.5rem', marginTop: '0', paddingTop: '0' }}>
                Medical alert bracelets are the perfect solution for those with chronic condition or health issues looking for ways to keep safe in case of an emergency. These bracelets work with your medical alert system to keep you safe.
              </p>
              
              <p style={{ marginBottom: '1.5rem' }}>
                Medical alert bracelets are comfortable, durable, and showerproof. You&rsquo;ll never have to be without quick access to help. Some folks might know medical alert bracelets as call buttons or panic buttons, but all serve the same purpose: to access help in the case of an emergency. Here&rsquo;s how they work:
              </p>
              
              <ul style={{ marginBottom: '2rem', paddingLeft: '2rem' }}>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>When you are in need of help, you simply press the <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>alarm button</Link> on your bracelet.</strong> An operator from the <Link to="/how-it-works" style={{ color: '#0066cc', textDecoration: 'underline' }}>Alert1 Command Center</Link> will come on the line to talk to you and send help your way, fast.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>The operator sends emergency responders from your Circle of Care to help you.</strong> When you sign up for a medical alert system you set up your custom Circle of Care. The Circle of Care is your personalized list of responders. We can call whomever you choose, whether that be a friend, family, a neighbor, or 911.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>The operator will stay connected with you the whole time.</strong> At Alert1, your safety is our #1 priority. That&rsquo;s why we promise that our operators will stay on the line with you until assistance arrives. We want to make sure you are safe.
                </li>
              </ul>
              
              <div style={{ textAlign: 'center', marginTop: '2rem', clear: 'both' }}>
                <Link 
                  to="/medical-alerts" 
                  className="btn btn-primary" 
                  style={{ 
                    display: 'inline-block',
                    padding: '1rem 2.5rem',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    backgroundColor: '#1a4d7a',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}
                >
                  VIEW PRODUCTS
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Sections from Original Page */}
      <section style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#333', textAlign: 'center' }}>
            You Can Accessorize Your Medical Alert Bracelet Too!
          </h2>
          
          <div style={{ overflow: 'hidden' }}>
            {accessorizeImage && (
              <img 
                src={accessorizeImage} 
                alt="Accessorized medical alert bracelet" 
                style={{ 
                  float: 'left',
                  maxWidth: '202px',
                  width: '100%',
                  height: 'auto',
                  marginRight: '2.5rem',
                  marginBottom: '1rem',
                  marginTop: '0',
                  paddingTop: '0',
                  borderRadius: '8px'
                }}
              />
            )}
            
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444', paddingLeft: '0.5rem' }}>
              <p style={{ marginBottom: '1.5rem', marginTop: '0', paddingTop: '0' }}>
                Users have several options to accessorize their medical alert systems.
              </p>
              
              <ul style={{ marginBottom: '2rem', paddingLeft: '2rem' }}>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Alert1 offers a wide range of <Link to="/accessories" style={{ color: '#0066cc', textDecoration: 'underline' }}>fashionable jewelry for women</Link>.</strong> You will love that you can wear your alarm button as a bracelet, or as a necklace.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>The jewelry is not only beautiful,</strong> but keeps you safe too. You can even customize the alarm button so it&rsquo;s easy to reach in case of emergencies. You will have protection, and style!
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Alert1 medical alert bracelets are slim and discreet!</strong> While some companies have created large medical alarm devices that are bulky and uncomfortable, Alert1 has focused on making its wearable medical alert buttons as slim and discreet as possible.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#333', textAlign: 'center' }}>
            Medical Alert Systems Ensure You Have Security and Peace of Mind.
          </h2>
          
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444', marginBottom: '1.5rem' }}>
            You can push your button for any reason, big or small. There are never any extra fees for pressing your button. No matter what happens, you can rest assured that we will be here for you.
          </p>
          
          <div style={{ overflow: 'hidden' }}>
            {designerCollectionImage && (
              <img 
                src={designerCollectionImage} 
                alt="Designer collection of medical alert accessories" 
                style={{ 
                  float: 'right',
                  maxWidth: '414px',
                  width: '100%',
                  height: 'auto',
                  marginLeft: '1.5rem',
                  marginBottom: '1rem',
                  borderRadius: '8px'
                }}
              />
            )}
            
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <ul style={{ marginBottom: '2rem', paddingLeft: '2rem' }}>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Press your button for whatever situation in which you may need.</strong> Press the help button in case of a fall, another type of medical emergency, or any issue requiring help from police, the fire department, friends or neighbors.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Stay protected throughout your home.</strong> With our medical alert bracelets, you are protected up to 600 feet around the medical alarm base. Enjoy your yard without worrying about your safety. A medical alert bracelet or necklace will be your constant companion on your journey as you age in place.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Our help buttons are 100% showerproof.</strong> You can have the security of our Command Center, 24/7. You will be protected while in the shower, getting the mail, going into the garage, or even watering the plants in the backyard.
                </li>
              </ul>
            </div>
          </div>
          
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444', marginBottom: '2rem', clear: 'both' }}>
            For all seniors aging in place, a wearable medical alert bracelet can reduce the stress of living alone or with a chronic condition. Fast assistance is available to you at the touch of a button. With Alert1, we are here for you 24/7, no matter what you need.
          </p>
          
          <div style={{ textAlign: 'center' }}>
            <Link 
              to="/medical-alerts" 
              className="btn btn-primary" 
              style={{ 
                display: 'inline-block',
                padding: '1rem 2.5rem',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                backgroundColor: '#1a4d7a',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '6px'
              }}
            >
              ORDER TODAY
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MedicalAlertBraceletsPage;
